// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CreateOffer_wrap__3P5r0","button":"CreateOffer_button__23FZp","addIcon":"CreateOffer_addIcon__3C3ZE"};